import ConfigUseCasesInterface from "./configInterface";
import { Config } from "../../../entities/config";
import configRepository from "../../../../infrastructure/repository/config/config_repository";

class ConfigUseCases implements ConfigUseCasesInterface {
  async get(): Promise<Config> {
    return await configRepository.get();
  }
}

export default new ConfigUseCases() as ConfigUseCasesInterface;
